import { Base } from '@studiometa/js-toolkit';
import Select from '../Select.js';

/**
 * LanguageSelectModal — modal for language switching.
 */
export default class LanguageSelectModal extends Base {
  isOpen = false;

  static config = {
    name: 'LanguageSelectModal',
    refs: ['close[]', 'panel'],
    components: {
      Select,
    },
  };

  /**
   * Close when pressing Escape key
   * @param {object} options
   * @param {boolean} options.ESC
   */
  keyed({ ESC }) {
    if (ESC) {
      this.close();
    }
  }

  /**
   * Close on close ref click
   */
  onCloseClick() {
    this.close();
  }

  /**
   * Open the modal
   */
  open() {
    this.isOpen = true;
    document.body.classList.add('overflow-hidden');
    this.$el.classList.remove('pointer-events-none', 'opacity-0');
    this.$refs.panel.classList.remove('translate-y-20', 'opacity-0');
  }

  /**
   * Close the modal
   */
  close() {
    this.isOpen = false;
    document.body.classList.remove('overflow-hidden');
    this.$refs.panel.classList.add('translate-y-20', 'opacity-0');
    this.$el.classList.add('pointer-events-none', 'opacity-0');
  }
}
